import React from 'react';
import { ColorPicker } from '../components/ColorPicker';
import { OptionCycler } from '../components/OptionCycler';
import { COLORS, SHAPES, AURAS } from '../CharacterCustomizer.constants';
import { TabProps } from './types';

export const BodyTab: React.FC<TabProps> = ({ appearance, setAppearance }) => {
  return (
    <div className="cc-section">
      <div className="cc-section-header">
        <div className="cc-section-title">Body Color</div>
        <span>Choose a spirit tone</span>
      </div>
      <ColorPicker
        colors={COLORS}
        selected={appearance.color}
        onSelect={c => setAppearance((p: any) => ({ ...p, color: c }))}
      />
      <div className="cc-field-grid cc-field-grid--body">
        <div className="cc-input-group">
          <label className="cc-label">Ghost Shape</label>
          <OptionCycler
            label="ghost shape"
            value={appearance.shape || 'classic'}
            options={SHAPES}
            onChange={v => setAppearance((p: any) => ({ ...p, shape: v as any }))}
          />
        </div>
        <div className="cc-input-group">
          <div className="cc-label-row">
            <label className="cc-label">Aura Effect</label>
            <span>Visible identity</span>
          </div>
          <OptionCycler
            label="aura effect"
            value={appearance.aura || 'none'}
            options={AURAS}
            onChange={v => setAppearance((p: any) => ({ ...p, aura: v as any }))}
          />
        </div>
        <div className="cc-input-group">
          <label className="cc-label">Body Size</label>
          <OptionCycler
            label="body size"
            value={appearance.bodySize || 'normal'}
            options={['small', 'normal', 'large']}
            onChange={v => setAppearance((p: any) => ({ ...p, bodySize: v as any }))}
          />
        </div>
      </div>
    </div>
  );
};
